export const LEGACY_SAVED_SYNASTRIES_KEY = 'zodiacus:savedSynastries';
export const LEGACY_SAVED_SYNASTRIES_KEYS = Object.freeze([
  LEGACY_SAVED_SYNASTRIES_KEY,
  'savedSynastries',
  'synastries:saved',
  'synastry:saved',
  'cosmicLibrary:synastries',
  'zodiacus:cosmic-library',
]);

export function clearLegacySavedSynastryStorage(storage) {
  try {
    const targetStorage = storage ?? (
      typeof window !== 'undefined' ? window.localStorage : null
    );
    for (const key of LEGACY_SAVED_SYNASTRIES_KEYS) targetStorage?.removeItem(key);
  } catch {
    // Privacy cleanup is best-effort and must not break the current screen.
  }
}
